<template>
  <div>
    <DraftAlert
      v-if="$path('item.draftId', $attrs) || $path('item.metadata.draftAvailable', $attrs)"
      :content="$t('integrationsNotPartOfDraft')"
      class="mb-2"
    />
    <Integration v-bind="{ ...$attrs, reference: { onModel: 'Project', ref: $route.params.id } }" v-on="$listeners" />
  </div>
</template>

<script>
import Integration, { meta as globalMeta } from '@/components/Integration/Step'
import DraftAlert from '@/components/Draft/Alert'

const meta = { ...globalMeta, order: 1007 }

export { meta }
export default {
  components: {
    Integration,
    DraftAlert,
  },
}
</script>
